import {
  Box,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "./Users.scss";
import { UserList } from "./UserList";
import { AddUser } from "./AddUser";
import store from "../../../store/store";
import { deletePartyApi, fetchOrgPartyDetailsApi } from "../../../store/api/party";
import ErrorPopup from "../../dialogBox/errorModal";
import SuccessDialog from "../../dialogBox/successDialog";
import { EditUser } from "./EditUser";
import { removeRelationshipTypesApi } from "../../../store/api/common";
import { PARTY_INACTIVE_STATUS } from "../../../shared/constants/constants";
type Props = {
  availableRoles:any[]
}
const Users = ({availableRoles}:Props) => {
  
  const [addClicked,setAddClicked] = useState(false)
  const [editClicked,setEditClicked] = useState(false)
  const [selectedUser, setSelectedUser] = useState(null);
  const [users,setUsers] = useState<any[]>([])
  const [success, setSuccess] = useState({ open: false, message: '' });
  const [error, setError] = useState({ open: false, message: '' });
  const [relations, setRelations] = useState<any>({})
  const [update, setUpdate] = useState<boolean>(false)
  const [pagination, setPagination] = useState({
    page: 1,
    pageSize: 10,
    totalRecords: 0
  })
  const [searchUser, setSearchUser] = useState<string>("");

  const handleUpdate = (user: any) => {
    // console.log(user)
    setSelectedUser(user);
    setEditClicked(true);
  };
  const handleDelete = async(userId:any, relation:any) => {
    const reqBody = {
      partyRelationshipId: relation[userId]?._id
    }
    // await store.dispatch(removeRelationshipTypesApi(reqBody)).unwrap().then((res)=>{
    //   if(res.status===200){
    //     setUpdate(!update)
    //     setSuccess({message:"Successfully Removed Relationship",open:true})
    //   }
    //   else{
    //     setError({message:"Remove User Relationship Failed",open:true})
    //   }
    // }).catch((err)=>{
    //   setError({message:"Remove User Relationship Failed",open:true})
    // })

    const deleteParty = {
      partyId: userId, 
      status: PARTY_INACTIVE_STATUS
    }
    await store.dispatch(deletePartyApi(deleteParty)).unwrap().then((res)=>{
      if(res.status === 200){
        setUpdate(!update)
        setSuccess({message:"Successfully Removed User",open:true})
      }
      else{
        setError({message:"Remove User Failed",open:true})
      }
    }).catch((err)=>{
      console.log(err)
      setError({message:"Remove User Failed",open:true})
    })
  }

  const handleAdd = () => {
    setAddClicked(true)
  };
  const cancelAdd = ()=> {
    setAddClicked(false)
  }
  const addUser = (reqBody:any) => {
    setUsers((prevState) => [...prevState,reqBody]);
  }
  const cancelEdit = ()=> {
    setEditClicked(false)
  }
  const editUser = (reqBody:any) => {
    const currUsers = users.filter((user: any)=>user._id != reqBody._id);
    setUsers((prevState) => [...currUsers,reqBody]);
    cancelEdit();
  }
  const handleCloseError = () => {
    setError({ ...error, open: false });
};
  const handleCloseSuccess = () => {
    setSuccess({ ...error, open: false });
};
  const handleSetSuccess = (message:string)=> {
    setSuccess({message,open:true})
  }
  const handleSetError = (message:string)=> {
    setError({message,open:true})
  }
  useEffect(()=> {
    store.dispatch(fetchOrgPartyDetailsApi({relationshipType:"", page: pagination.page, search: searchUser})).unwrap().then((res:any)=> {
      // console.log(res?.data)
      setRelations(res?.data?.relationships)
     setUsers(res?.data?.parties)
     setPagination({...pagination, totalRecords: res.data?.totalRecords})
    })
  },[update, pagination.page]);

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    if (value !== pagination.page) {
      setPagination({...pagination, page: value});
    }
  };

  return (
    <>
      <Box className="usersMainContainer">
       {
        addClicked === false && editClicked === false ? 
       <UserList relations={relations}  handleUpdate={handleUpdate} handleDelete = {handleDelete} handleAdd={handleAdd} users={users} handlePageChange={handlePageChange} pagination={pagination} setPagination={setPagination} searchUser={searchUser} setSearchUser={setSearchUser} update={update} setUpdate={setUpdate} />
        :
        !editClicked ?
        <AddUser cancelAdd={cancelAdd} addUser={addUser} handleSetSuccess={handleSetSuccess} handleSetError={handleSetError}/>
        :
        <EditUser user = {selectedUser} cancelEdit={cancelEdit} editUser={editUser} handleSetSuccess={handleSetSuccess} handleSetError={handleSetError}/>
       } 
      </Box>
        <ErrorPopup
          open={error.open}
          message={error.message}
          onClose={handleCloseError}
        />
        <SuccessDialog
          open={success.open}
          message={success.message}
          onClose={handleCloseSuccess}
        />
    </>
  );
};

export default Users;



